import * as React from 'react';

import arrowLeft from '../../../../assets/images/arrow-left.svg';
import arrowRight from '../../../../assets/images/arrow-right.svg';

interface IProps {
    onClick?: () => void;
    to: 'prev' | 'next';
}

export const Arrow: React.FC<IProps> = ({ onClick, to }) => (
    <div onClick={onClick} className={`${to === 'prev' ? 'button--prev' : 'button--next'}`}>
        {to === 'prev' ? <img src={arrowLeft} alt="" /> : <img src={arrowRight} alt="" />}
    </div>
);
